module.exports = __webpack_public_path__ + "img/customReport.bd67d98d.png";